(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["market-andino-chat-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.querySelector('[data-ma-q]');
  if(!root||root.dataset.ready)return;
  root.dataset.ready='1';

  const dialog=root.querySelector('[data-ma-dialog]');
  const messages=root.querySelector('[data-ma-messages]');
  const form=root.querySelector('[data-ma-form]');
  const input=root.querySelector('[data-ma-input]');
  const handoff=root.querySelector('[data-ma-handoff]');
  const handoffText=root.querySelector('[data-ma-handoff-text]');
  const wa=root.querySelector('[data-ma-whatsapp]');
  const capture=root.querySelector('#MarketAndinoQualifiedLeadForm');

  const fresh=()=>({
    stage:'name',
    name:'',
    product:'',
    sacks:null,
    frequency:'',
    business:'',
    location:'',
    phone:'',
    docType:'',
    doc:'',
    docPending:false,
    done:false,
    closed:false,
    captured:false
  });
  let s=fresh();

  const norm=t=>(t||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
  const add=(text,who='bot')=>{
    const row=document.createElement('div');
    row.className='ma-q__row ma-q__row--'+who;
    const bubble=document.createElement('div');
    bubble.className='ma-q__bubble';
    bubble.textContent=text;
    row.appendChild(bubble);
    messages.appendChild(row);
    messages.scrollTop=messages.scrollHeight;
  };
  const reply=text=>setTimeout(()=>add(text,'bot'),160);

  const priceIntent=n=>/\b(precio|precios|cuanto cuesta|cuanto esta|a cuanto|costo|sale|vale)\b/.test(n);
  const urgentIntent=n=>/\b(urgente|lo necesito hoy|necesito hoy|comprar hoy|ahora mismo|cuando me contact|cuando me llaman|cuanto demora|cuanto tarda)\b/.test(n);
  const personalUse=n=>/\b(mi casa|para casa|consumo personal|para mi familia|uso personal)\b/.test(n);
  const noRuc=n=>/^(no|no tengo|no tengo ruc|sin ruc|no cuento con ruc|no poseo ruc|no contamos con ruc)[.! ]*$/.test(n);
  const yesAnswer=n=>/^(si|sí|claro|correcto|tengo ruc|si tengo|sí tengo)[.! ]*$/.test(n);

  const extractName=t=>{
    let x=(t||'').trim();
    x=x.replace(/^(hola[,\s]*)/i,'').replace(/^(me llamo|mi nombre es|soy)\s+/i,'').trim();
    if(!x||x.length>60)return'';
    const n=norm(x);
    if(/\d/.test(x)||priceIntent(n)||personalUse(n)||/\b(quiero|comprar|busco|necesito|arroz|arros|azucar|fideo|bodega|mercado|restaurante|saco|sacos|semanal|mensual|quincenal|ruc|dni)\b/.test(n))return'';
    if(!/^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ.' -]+$/.test(x))return'';
    return x.replace(/\s+/g,' ');
  };

  const extractProduct=t=>{
    const raw=(t||'').trim();
    const n=norm(raw);
    if(!raw||/^(no se|no sé|no entiendo|ninguno|nada|x|asdf)$/i.test(raw))return'';

    const brands=[
      ['fray martin','Fray Martín'],['frey martin','Fray Martín'],['taypa negro','Taypa Negro'],
      ['taypa celeste','Taypa Celeste'],['agricultor','Agricultor'],['paramonga','Paramonga'],
      ['lampos azul','Lampos Azul'],['lampos rojo','Lampos Rojo'],['perla naranja','Perla Naranja'],
      ['perla amarillo','Perla Amarillo'],['misti','Misti'],['caserita','Caserita'],
      ['cusi cusa','Cusi Cusa'],['manuelita','Manuelita'],['cartavio','Cartavio'],
      ['cana brava','Caña Brava'],['chacrita','Chacrita'],['jairito','Jairito'],
      ['pacasmayo','Pacasmayo'],['pirata','Pirata'],['valentina','Valentina'],
      ['faraon','Faraón'],['hacienda','Hacienda'],['cultivos verdes','Cultivos Verdes'],
      ['power','Power']
    ];
    const brand=brands.find(([key])=>n.includes(key));
    if(brand)return brand[1];

    if(/\b(fideo|fideos|pasta|tallarin|tallarines|spaghetti|espagueti)\b/.test(n))return'Fideos';
    if(/\b(aceite|aceites)\b/.test(n))return'Aceite';
    if(/\b(atun|atunes)\b/.test(n))return'Atún';
    if(/\b(arroz|arroces|arros)\b/.test(n))return'Arroz';
    if(/\b(azucar|azucares)\b/.test(n))return'Azúcar';
    return'';
  };

  const purchaseUnit=product=>{
    const n=norm(product);
    if(/\b(fideo|fideos|pasta|tallarin|tallarines|spaghetti|espagueti)\b/.test(n))return'paquetes';
    if(/\b(aceite|atun)\b/.test(n))return'cajas';
    if(/\b(arroz|azucar)\b/.test(n))return'sacos';
    return'unidades';
  };

  const extractQuantity=n=>{
    const m=n.match(/\b(\d{1,4})\s*(?:sacos?|bolsas?|paquetes?|cajas?|unidades?)?\b/);
    if(m)return Number(m[1]);
    const words={
      'diez':10,'quince':15,'veinte':20,'veinticinco':25,'treinta':30,'cuarenta':40,
      'cincuenta':50,'sesenta':60,'setenta':70,'ochenta':80,'noventa':90,'cien':100
    };
    for(const [word,value] of Object.entries(words)){
      if(new RegExp('\\b'+word+'\\b').test(n))return value;
    }
    return null;
  };

  const extractFrequency=n=>{
    if(/\b(diari|cada dia|todos los dias)\b/.test(n))return'Diaria';
    if(/\b(semanal|cada semana|todas las semanas|por semana|semanalmente|cada 7 dias|cada siete dias)\b/.test(n))return'Semanal';
    if(/\b(quincenal|cada quincena|cada 15 dias|cada quince dias)\b/.test(n))return'Quincenal';
    if(/\b(mensual|cada mes|por mes|mensualmente)\b/.test(n))return'Mensual';
    if(/\b(ocasional|una vez|solo una vez|pedido unico)\b/.test(n))return'Ocasional';
    return'';
  };

  const extractBusiness=t=>{
    const n=norm(t);
    const map=[
      ['bodega','Bodega'],['tienda','Tienda / bodega'],['abarrote','Tienda de abarrotes'],
      ['restaurante','Restaurante'],['chifa','Restaurante'],['polleria','Restaurante'],
      ['cevicheria','Restaurante'],['minimarket','Minimarket'],['puesto','Puesto de mercado'],
      ['mercado','Mercado'],['distribuidor','Distribuidora'],['mayorista','Distribuidora'],
      ['almacen','Almacén'],['empresa','Empresa'],['hotel','Hotel'],['panader','Panadería']
    ];
    const hit=map.find(([k])=>n.includes(k));
    return hit?hit[1]:'';
  };

  const extractPhone=t=>{
    let d=(t||'').replace(/\D/g,'');
    if(d.startsWith('51')&&d.length===11)d=d.slice(2);
    if(/^9\d{8}$/.test(d))return d;
    return'';
  };

  const currentQuestion=()=>{
    switch(s.stage){
      case'name': return'¿Con quién tengo el gusto?';
      case'product': return'Mucho gusto, '+s.name+'. ¿Qué producto estás buscando para tu negocio?';
      case'quantity': return'Perfecto. Aproximadamente, ¿cuántos '+purchaseUnit(s.product)+' compras por pedido?';
      case'frequency': return'¿Con qué frecuencia haces esa compra: diaria, semanal, quincenal o mensual?';
      case'business': return'¿Es para una bodega, restaurante, puesto de mercado, distribuidora u otro negocio?';
      case'location': return'¿En qué distrito y mercado o zona está ubicado tu negocio?';
      case'phone': return'Perfecto. ¿Cuál es tu número de WhatsApp? Así un asesor podrá contactarte si no puedes escribirnos en ese momento.';
      case'document': return'Para completar la ficha comercial, ¿tu negocio cuenta con RUC?';
      case'ruc_number': return'Perfecto. Indícame el número de RUC de 11 dígitos.';
      default:return'';
    }
  };

  const setLead=(key,value)=>{
    if(!capture)return;
    const el=capture.querySelector('[data-lead="'+key+'"]');
    if(el)el.value=value||'';
  };

  const saveLead=(force=false)=>{
    if(!capture||(s.captured&&!force))return;
    s.captured=true;
    const body=[
      'SOLICITUD PRECALIFICADA - MARKET ANDINO',
      'Responsable: '+s.name,
      'WhatsApp: '+s.phone,
      'Producto: '+s.product,
      'Cantidad: '+s.sacks+' '+purchaseUnit(s.product),
      'Frecuencia: '+s.frequency,
      'Negocio: '+s.business,
      'Ubicación: '+s.location,
      'RUC: '+(s.doc? s.doc : 'No cuenta con RUC'),
      'Origen: Asistente mayorista web'
    ].join('\n');

    setLead('name',s.name);
    setLead('phone',s.phone);
    setLead('product',s.product);
    setLead('sacks',String(s.sacks||''));
    setLead('frequency',s.frequency);
    setLead('business',s.business);
    setLead('location',s.location);
    setLead('doc',s.doc||'No cuenta con RUC');
    setLead('body',body);

    capture.target='ma-lead-target';
    try{
      if(typeof capture.requestSubmit==='function') capture.requestSubmit();
      else capture.submit();
    }catch(_){}
  };

  const prepareHandoff=()=>{
    s.done=true;
    s.stage='done';

    const summary=[
      '*SOLICITUD PRECALIFICADA - MARKET ANDINO*',
      'Responsable: '+s.name,
      'WhatsApp: '+s.phone,
      'Producto: '+s.product,
      'Cantidad: '+s.sacks+' '+purchaseUnit(s.product),
      'Frecuencia: '+s.frequency,
      'Negocio: '+s.business,
      'Ubicación: '+s.location,
      'RUC: '+(s.doc? '*******'+s.doc.slice(-4) : 'No cuenta con RUC')
    ].join('\n');

    wa.href='https://wa.me/51930387605?text='+encodeURIComponent(summary+'\n\nDeseo continuar con un asesor comercial.');
    handoffText.textContent='Listo, '+s.name+'. Ya registramos tu solicitud y tu número de WhatsApp.';
    handoff.hidden=false;
    saveLead();

    reply('Tu solicitud quedó precalificada y registrada. Si quieres avanzar ahora, pulsa “Enviar solicitud por WhatsApp”. Si no, un asesor podrá contactarte al número que nos brindaste.');
  };

  const closeNotFit=()=>{
    s.closed=true;
    s.stage='closed';
    reply('Gracias por la información, '+s.name+'. Por ahora ese volumen no encaja con nuestra atención mayorista. Si más adelante aumenta tu compra, con gusto podemos reevaluarlo.');
  };

  const handleGlobal=(t,n)=>{
    if(s.done){
      if(/\b(que me contacte|contactame|contactenme|que me llamen|llamenme)\b/.test(n)){
        reply('Claro. Ya registramos tu solicitud y el WhatsApp '+s.phone+'. Un asesor podrá contactarte por ese número. Si prefieres avanzar ahora, usa el botón “Enviar solicitud por WhatsApp”.');
      }else if(urgentIntent(n)){
        reply('Tu solicitud ya está registrada. Si necesitas avanzar ahora mismo, pulsa “Enviar solicitud por WhatsApp”.');
      }else if(priceIntent(n)){
        reply('Los precios se confirman con el asesor comercial según producto, volumen, frecuencia y zona. Ya puedes continuar con el botón de WhatsApp.');
      }else{
        reply('Tu solicitud ya quedó registrada. Puedes esperar el contacto del asesor o avanzar ahora por WhatsApp con el botón de abajo.');
      }
      return true;
    }

    if(s.closed){
      reply('Tu consulta quedó cerrada por ahora. Si cambia tu volumen de compra, puedes iniciar una nueva evaluación.');
      return true;
    }

    if(priceIntent(n)){
      if(s.stage==='product'){
        const p=extractProduct(t);
        if(p&&p.length>2){s.product=p;s.stage='quantity'}
      }
      reply('Los precios mayoristas se confirman según producto, volumen, frecuencia y zona de atención. '+currentQuestion());
      return true;
    }

    if(urgentIntent(n)){
      reply('Entiendo que necesitas avanzar rápido. Primero termino esta evaluación para derivarte correctamente. '+currentQuestion());
      return true;
    }

    return false;
  };

  const process=t=>{
    const raw=(t||'').trim();
    const n=norm(raw);
    if(!raw)return;
    if(handleGlobal(raw,n))return;

    if(s.stage==='name'){
      const name=extractName(raw);
      if(!name){
        reply('Antes de continuar, dime solo tu nombre para registrarte correctamente.');
        return;
      }
      s.name=name;
      s.stage='product';
      reply('Mucho gusto, '+s.name+'. ¿Qué producto estás buscando para tu negocio?');
      return;
    }

    if(s.stage==='product'){
      const p=extractProduct(raw);
      if(!p){
        reply('No entendí bien qué producto buscas. Escríbeme, por ejemplo: arroz Fray Martín, azúcar Paramonga, fideos, aceite o atún.');
        return;
      }
      s.product=p;
      const qty=extractQuantity(n);
      if(qty!==null){
        s.sacks=qty;
        if(s.sacks<20){closeNotFit();return}
        s.stage='frequency';
        reply('Perfecto, '+s.sacks+' '+purchaseUnit(s.product)+'. ¿Con qué frecuencia haces esa compra: diaria, semanal, quincenal o mensual?');
        return;
      }
      s.stage='quantity';
      reply('Perfecto. Aproximadamente, ¿cuántos '+purchaseUnit(s.product)+' compras por pedido?');
      return;
    }

    if(s.stage==='quantity'){
      const qty=extractQuantity(n);
      if(qty===null){
        reply('Necesito solo una cantidad aproximada. ¿Cuántos '+purchaseUnit(s.product)+' compras por pedido?');
        return;
      }
      s.sacks=qty;
      if(s.sacks<20){closeNotFit();return}
      s.stage='frequency';
      reply('Gracias. ¿Con qué frecuencia haces esa compra: diaria, semanal, quincenal o mensual?');
      return;
    }

    if(s.stage==='frequency'){
      const f=extractFrequency(n);
      if(!f){
        reply('No entendí la frecuencia. Indícame si compras diaria, semanal, quincenal o mensualmente.');
        return;
      }
      s.frequency=f;
      s.stage='business';
      reply('¿Es para una bodega, restaurante, puesto de mercado, distribuidora u otro negocio?');
      return;
    }

    if(s.stage==='business'){
      if(personalUse(n)){closeNotFit();return}
      const b=extractBusiness(raw);
      if(!b){
        reply('No entendí el tipo de negocio. Indícame si es bodega, tienda de abarrotes, restaurante, puesto de mercado, minimarket o distribuidora.');
        return;
      }
      s.business=b;
      s.stage='location';
      reply('Perfecto. ¿En qué distrito y mercado o zona está ubicado tu negocio?');
      return;
    }

    if(s.stage==='location'){
      if(raw.length<3||/^(no se|no sé|no entiendo|ninguno|nada|x|asdf)$/i.test(raw)){
        reply('No entendí la ubicación. Indícame el distrito y, si aplica, el mercado o zona de tu negocio.');
        return;
      }
      s.location=raw;
      s.stage='phone';
      reply('Bien, '+s.name+'. Tu solicitud sí puede pasar a evaluación comercial. ¿Cuál es tu número de WhatsApp? Así un asesor podrá contactarte si no puedes escribirnos en ese momento.');
      return;
    }

    if(s.stage==='phone'){
      const phone=extractPhone(raw);
      if(!phone){
        reply('Indícame un número de WhatsApp válido de 9 dígitos, por ejemplo 9XXXXXXXX.');
        return;
      }
      s.phone=phone;
      saveLead(false);
      s.stage='document';
      reply('Perfecto. Ya registré tu solicitud y tu WhatsApp para que no se pierda el contacto. Para completar la ficha comercial, ¿tu negocio cuenta con RUC?');
      return;
    }

    if(s.stage==='document'){
      const d=(raw||'').replace(/\D/g,'');
      if(d.length===11){
        s.docType='RUC';
        s.doc=d;
        prepareHandoff();
        return;
      }
      if(yesAnswer(n)){
        s.stage='ruc_number';
        reply('Perfecto. Indícame el número de RUC de 11 dígitos.');
        return;
      }
      if(noRuc(n)){
        s.docType='SIN RUC';
        s.doc='';
        reply('No hay problema. Continuemos.');
        setTimeout(prepareHandoff,220);
        return;
      }
      reply('Respóndeme solo “sí” o “no”. ¿Tu negocio cuenta con RUC?');
      return;
    }

    if(s.stage==='ruc_number'){
      const d=(raw||'').replace(/\D/g,'');
      if(d.length===11){
        s.docType='RUC';
        s.doc=d;
        prepareHandoff();
        return;
      }
      if(noRuc(n)){
        s.docType='SIN RUC';
        s.doc='';
        reply('No hay problema. Continuemos.');
        setTimeout(prepareHandoff,220);
        return;
      }
      reply('El RUC debe tener 11 dígitos. Indícame el número de RUC de tu negocio.');
      return;
    }
  };

  const reset=()=>{
    s=fresh();
    messages.innerHTML='';
    handoff.hidden=true;
    add('¡Hola! 👋 Soy el asistente mayorista de Market Andino. ¿Con quién tengo el gusto?','bot');
  };

  const open=()=>{
    if(!messages.children.length)reset();
    dialog.showModal?dialog.showModal():dialog.setAttribute('open','');
    setTimeout(()=>input.focus(),100);
  };

  document.addEventListener('click',e=>{
    const trigger=e.target.closest('.js-market-andino-open-chat');
    if(!trigger)return;
    e.preventDefault();
    open();
  });

  root.querySelector('[data-ma-close]').addEventListener('click',()=>dialog.close?dialog.close():dialog.removeAttribute('open'));

  wa.addEventListener('click',()=>{
    saveLead(true);
  });

  form.addEventListener('submit',e=>{
    e.preventDefault();
    const text=input.value.trim();
    if(!text)return;
    add(text,'user');
    input.value='';
    process(text);
  });

  input.addEventListener('keydown',e=>{
    if(e.key==='Enter'&&!e.shiftKey){
      e.preventDefault();
      form.requestSubmit();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
